import { toast } from "react-toastify";
import APIS from "../../../../../constant/Endpoint";
import { postApiFormData } from "../../../../../helpers/AxiosInstance";

export class API {
  public static uploadImage = async (
    file: File
  ): Promise<string | ArrayBuffer | null> => {
    try {
      const uploadUrl = APIS.FILE_HANDLER;
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await postApiFormData({
        url: uploadUrl,
        formData,
        setError: () => {
          return;
        },
      });
      return data.file;
    } catch (e) {
      toast.error(`File ${file.name} to large`);
    }
  };
}

export default API;
